export var MessageReaction;
(function (MessageReaction) {
    MessageReaction["LIKE"] = "\uD83D\uDC4D";
    MessageReaction["LOVE"] = "\u2764\uFE0F";
    MessageReaction["CARE"] = "\uD83E\uDD17";
    MessageReaction["HAHA"] = "\uD83D\uDE02";
    MessageReaction["WOW"] = "\uD83D\uDE2E";
    MessageReaction["SAD"] = "\uD83D\uDE22";
    MessageReaction["ANGRY"] = "\uD83D\uDE20";
})(MessageReaction || (MessageReaction = {}));
//# sourceMappingURL=message-reaction.const.js.map